<template>
  <div>
    <div id="user-active" style="height: 400px; width: 488px"></div>
  </div>
</template>

<script>
export default {
  props: ['userActive'],
  watch:{
 userActive: function (newVal, oldVal){

   this.createChart();
 }
  },
 
  mounted() {
    this.createChart();
  },
  methods: {
    createChart() {
      let that = this
      var chartDom = document.getElementById("user-active");
      var myChart = this.$echarts.init(chartDom);
      var option;

      option = {
        legend: {
          itemWidth: 16,
          itemHeight: 8,
          itemGap: 27,
          orient: "vertical",
          left: "right",
          y: 230,
        },
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          //   formatter: "{b}用户: {c} ({d}%)",
          formatter: "{b}用户: {c}人\n {d}%",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        series: [
          {
            name: "面积模式",
            type: "pie",
            radius: [50, 100],
            center: ["50%", "50%"],
            // roseType: "area",
            data: [
              { name: "高度活跃", value: that.userActive.activeHigh },
              { name: "中度活跃", value: that.userActive.activeModerate },
              { name: "低度活跃", value: that.userActive.activeLow },
            ],
            labelLine: {
              show: true,
              smooth: 0.1,
              length: 15,
              length2: 25,
              color: "#4E97D6",
              lineStyle: {
                color: "#4E97D6",
              },
            },

            //控制引导线上文字颜色和位置,此处a是显示文字区域，b做一个小圆圈在引导线尾部显示
            label: {
              show: true,
              formatter: "{d}%",
              fontSize: "10",
              fontWeight: "bold",
              color: "#434343",
              position: "outside",
              //a和b来识别不同的文字区域
              formatter: [
                "{a|{d}% }", //引导线上面文字
                "{b|}", //引导线下面文字
              ].join("\n"), //用\n来换行
              rich: {
                a: {
                  left: 30,
                  padding: [0, 10, -20, 10],
                },
                b: {
                  height: 5,
                  width: 5,
                  lineHeight: 5,
                  marginBottom: 10,
                  padding: [0, -5],
                  borderRadius: 5,
                  borderWidth: 1,
                  borderColor: "#4E97D6",
                },
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang="scss">
#user-active {
  margin: 0 auto;
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/groupPortrait/UserActiveRatio.vue